export default __webpack_public_path__ + "static/media/sphero-standard-class-icon.9ef82405.svg";